/* @flow */
import React from 'react';
import Layout from '../../components/Layout';
import ServicesPage from './Services';

import { getCityConfig } from '../../apiUtils';
import { setCity } from '../../actions/city';
import { getServiceData } from '../../actions/services';

async function action({ fetch, store, params }) {
	const { cityConfig, services } = store.getState();

	const city = setCity({
		store,
		params,
		fetch,
	});

	if (!cityConfig) {
		await getCityConfig(city.cityIds, {
			store,
			fetch,
		});
	}

	if (!services.isLoaded && !services.isLoading && Object.keys(services.data).length < 1) {
		await getServiceData()(store.dispatch, store.getState, { fetch });
	}

	const title = 'Услуги';

	return {
		chunks: ['service'],
		title,
		component: (
			<Layout route="service">
				<ServicesPage />
			</Layout>
		),
	};
}

export default action;
